import { debounce } from "lodash";
import { get } from "../helpers/api";
import { PageProps } from "../pages/_app";
import { useEffect, useState } from "react";

export interface UseUserInfoProps {
    pageProps: PageProps;
    fetchOnInit?: boolean;
}

export type ID_CHECK_STATUS = "not_started" | "pending" | "passed" | "resubmission" | "declined" | "expired";

export interface UserInfo {
    type: string;
    email: string;
    is_connected: boolean;
    sso_details: string;
    last_name: string;
    verified: boolean;
    first_name: string;
    phone_number_verified: boolean;
    phone_number: string;
    id_check: ID_CHECK_STATUS;
}

function useUserInfo(props: UseUserInfoProps) {
    const { pageProps, fetchOnInit } = props;

    const [userInfo, setUserInfo] = useState<UserInfo>();

    const methods = {
        async fetchUserInfo(email?: string, id?: string) {
            let url = "/user-info";

            if (email) {
                url += `?email=${email}`;
            } else if (id) {
                url += `?id=${id}`;
            }

            const result = await get(url);

            if (result.error) {
                pageProps.showAlert(result.error);
            } else {
                setUserInfo(result);

                return result;
            }
        },
    };

    useEffect(() => {
        if (fetchOnInit) {
            const debounced = debounce(methods.fetchUserInfo, 50);

            debounced();

            return () => {
                debounced.cancel();
            };
        }
    }, []);

    return { userInfo, fetchUserInfo: methods.fetchUserInfo };
}

export default useUserInfo;
